<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<div class="p-fluid">

  <app-warehousing-page-header activeSection="items" title="Item Master"
    subtitle="Client-owned warehouse items with hierarchy, dimensions, images, barcodes, and tracking rules.">
    <div actions class="flex gap-2">
      <p-button label="New Item" icon="pi pi-plus" routerLink="/warehousing/items/add"></p-button>
      <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="loadItems()"></p-button>
    </div>
  </app-warehousing-page-header>

  <app-warehousing-search-panel title="Search Items" [resultCount]="items.length" [totalCount]="totalRecords" (search)="applySearch()" (clear)="clearSearch()">
    <div [formGroup]="searchForm" class="formgrid grid">
      <div class="field col-12 md:col-4">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon><p-iftaLabel><input id="itemKeyword" pInputText formControlName="keyword"><label for="itemKeyword">Keyword</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-4">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-box"></i></p-inputGroupAddon><p-iftaLabel><p-autoComplete inputId="itemFilter" formControlName="item" [suggestions]="itemOptions" optionLabel="displayLabel" [forceSelection]="true" [showClear]="true" [delay]="300" [minLength]="1" appendTo="body" styleClass="w-full" (completeMethod)="searchItemOptions($event)"></p-autoComplete><label for="itemFilter">Item</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-4">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-warehouse"></i></p-inputGroupAddon><p-iftaLabel><p-select id="itemWarehouse" [options]="masterData.WAREHOUSE" optionLabel="name" optionValue="id" formControlName="warehouseId" [filter]="true" [showClear]="true" styleClass="w-full"></p-select><label for="itemWarehouse">Warehouse</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-4">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon><p-iftaLabel><p-select id="itemClient" [options]="clients" optionLabel="companyName" optionValue="id" formControlName="crmClientId" [filter]="true" [showClear]="true" styleClass="w-full"></p-select><label for="itemClient">Client</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-4">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon><p-iftaLabel><p-select id="itemAccount" [options]="filteredAccounts(searchForm.value.crmClientId)" optionLabel="companyName" optionValue="id" formControlName="crmAccountId" [filter]="true" [showClear]="true" styleClass="w-full"></p-select><label for="itemAccount">Account</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-4">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-folder"></i></p-inputGroupAddon><p-iftaLabel><p-select id="itemCategory" [options]="categoryOptions()" optionLabel="name" optionValue="id" formControlName="categoryId" [filter]="true" filterBy="name,code,hierarchyPath" [showClear]="true" styleClass="w-full"></p-select><label for="itemCategory">Category</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-4">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-star"></i></p-inputGroupAddon><p-iftaLabel><p-select id="itemBrand" [options]="brandOptions()" optionLabel="name" optionValue="id" formControlName="brandId" [filter]="true" filterBy="name,code,hierarchyPath" [showClear]="true" styleClass="w-full"></p-select><label for="itemBrand">Brand</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-4">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-sparkles"></i></p-inputGroupAddon><p-iftaLabel><p-select id="itemSubBrand" [options]="subBrandOptions()" optionLabel="name" optionValue="id" formControlName="subBrandId" [filter]="true" filterBy="name,code,hierarchyPath" [showClear]="true" styleClass="w-full"></p-select><label for="itemSubBrand">Sub Brand</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-shield"></i></p-inputGroupAddon><p-iftaLabel><p-select id="itemTracking" [options]="trackingModes" optionLabel="label" optionValue="value" formControlName="trackingMode" [showClear]="true" styleClass="w-full"></p-select><label for="itemTracking">Tracking</label></p-iftaLabel></p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup><p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon><p-iftaLabel><p-select id="itemActiveStatus" [options]="activeFilterOptions" optionLabel="label" optionValue="value" formControlName="activeStatus" [showClear]="true" styleClass="w-full"></p-select><label for="itemActiveStatus">Status</label></p-iftaLabel></p-inputGroup>
      </div>
    </div>
  </app-warehousing-search-panel>

  <section class="warehousing-table-card">
    <div class="warehousing-table-header">
      <div>
        <h2>Item Directory</h2>
        <p>Client-owned warehouse items with dimensions, hierarchy, and tracking rules.</p>
      </div>
      <span class="warehousing-result-chip">{{ totalRecords }} records</span>
    </div>
    <p-table [value]="items" [paginator]="true" [lazy]="true" [loading]="isLoading" [first]="first" [rows]="rows" [totalRecords]="totalRecords" (onLazyLoad)="loadItems($event)" dataKey="id" styleClass="p-datatable-sm p-datatable-gridlines warehousing-data-table" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[12, 25, 50]" [tableStyle]="{ 'min-width': '75rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Item Profile</th>
          <th>Ownership</th>
          <th>Classification</th>
          <th>Storage</th>
          <th>Inventory</th>
          <th>Status</th>
          <th>Audit</th>
          <th class="text-center">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <div class="item-profile-cell">
              <img *ngIf="item.thumbnailUrl && !isThumbnailFailed(item.id); else thumbnailPlaceholder" class="item-thumbnail" [src]="item.thumbnailUrl" [alt]="item.itemName + (itemSizeLabel(item) ? ' ' + itemSizeLabel(item) : '') + ' thumbnail'" width="40" height="40" loading="lazy" decoding="async" (error)="markThumbnailFailed(item.id)">
              <ng-template #thumbnailPlaceholder><span class="item-thumbnail-placeholder" aria-label="No item thumbnail"><i class="pi pi-image"></i></span></ng-template>
              <div class="stack-cell">
                <span class="warehousing-code-pill">{{ item.itemNumber || '-' }}</span>
                <div><a class="cell-title" [routerLink]="['/warehousing/items/view', item.id]">{{ item.itemName }}</a></div>
                <div class="cell-meta">
                  <span><i class="pi pi-id-card"></i> {{ item.customerItemNumber || 'No customer item #' }}</span>
                  <span><i class="pi pi-barcode"></i> {{ item.itemBarcode || 'No barcode' }}</span>
                  <span *ngIf="item.skuNumber"><i class="pi pi-qrcode"></i> {{ item.skuNumber }}</span>
                  <span *ngIf="itemSizeLabel(item)"><i class="pi pi-expand"></i> {{ itemSizeLabel(item) }}</span>
                  <span><i class="pi pi-list-check"></i> {{ item.tenantUomName || masterName('TENANT_UOM', item.tenantUomId) }}</span>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="stack-cell">
              <span class="cell-title">{{ clientName(item.crmClientId) }}</span>
              <div class="cell-meta vertical">
                <span><i class="pi pi-building"></i> {{ accountName(item.crmAccountId) }}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="stack-cell">
              <span class="cell-title">{{ hierarchyLabel(item) }}</span>
              <div class="cell-meta">
                <span><i class="pi pi-folder"></i> {{ item.categoryName || masterName('CATEGORY', item.categoryId) }}</span>
                <span><i class="pi pi-star"></i> {{ item.brandName || masterName('BRAND', item.brandId) }}</span>
              </div>
            </div>
          </td>
          <td>
            <div class="stack-cell">
              <div class="cell-meta vertical">
                <div class="quality-pill">SQM {{ item.sqm | number:'1.2-4' }}</div>
                <div class="quality-pill">CBM {{ item.cbm | number:'1.2-4' }}</div>
              </div>
              <p-tag [value]="item.trackingMode === 'UNIT' ? 'UNIT TRACKING' : 'QUANTITY'" [severity]="item.trackingMode === 'UNIT' ? 'warn' : 'info'"></p-tag>
            </div>
          </td>
          <td>
            <div class="stack-cell">
              <div class="cell-meta vertical">
                <span><strong>On hand:</strong> {{ item.onHandQuantity | number:'1.0-4' }}</span>
                <span class="text-orange-700"><strong>Reserved:</strong> {{ item.reservedQuantity | number:'1.0-4' }}</span>
                <span class="text-green-700 font-semibold"><strong>Available:</strong> {{ item.availableQuantity | number:'1.0-4' }}</span>
              </div>
            </div>
          </td>
          <td><p-tag [value]="item.isActive === false ? 'INACTIVE' : 'ACTIVE'" [severity]="item.isActive === false ? 'secondary' : 'success'"></p-tag></td>
          <td><app-audit-directory-cell [stamp]="item"></app-audit-directory-cell></td>
          <td class="text-center">
            <div class="warehousing-row-actions">
              <p-button icon="pi pi-eye" [text]="true" [routerLink]="['/warehousing/items/view', item.id]"></p-button>
              <p-button icon="pi pi-pencil" [text]="true" severity="info" [routerLink]="['/warehousing/items/edit', item.id]"></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="8"><div class="warehousing-empty-state"><i class="pi pi-search"></i><strong>No warehousing items found</strong><span>No matching item records.</span></div></td></tr>
      </ng-template>
    </p-table>
  </section>
</div>
